import React, { useState } from "react"
import { green, grey } from "@material-ui/core/colors"
import { useTranslation } from "react-i18next"

import Box from "@material-ui/core/Box"
import Link from "@material-ui/core/Link"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import DialogMui from "@material-ui/core/Dialog"
import Typography from "@material-ui/core/Typography"
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction"

import Chip from "../Chip"
import CatalogFormDialog from "./CatalogFormDialog"
import { DialogTitle } from "components/partials"

const Catalogs = props => {
  const { t } = useTranslation()
  const [itemEdit, setItemEdit] = useState(null)
  const [isListDialogOpen, setIsListDialogOpen] = useState(false)
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false)

  const { company, max = 5 } = props
  const { catalogs } = company
  const catalogsCount = catalogs.length
  const catalogsLast = max - 1

  const toggleListDialog = state => () => {
    setIsListDialogOpen(state)
  }

  const toggleEditDialog = state => () => {
    setIsEditDialogOpen(state)
  }

  const setItem = item => () => {
    setItemEdit(item)
    toggleEditDialog(item !== null)()
  }

  return (
    <>
      <Box display="flex" flexWrap="wrap" alignItems="center" gridGap={5}>
        {catalogs.slice(0, catalogsLast).map(catalog => (
          <Chip
            key={catalog.id}
            label={catalog.name}
            onClick={setItem(catalog)}
          />
        ))}
        {catalogsCount >= max && (
          <Link
            href={void 0}
            onClick={toggleListDialog(true)}
            style={{ cursor: "pointer" }}
          >
            {`+${catalogsCount - catalogsLast} ${t("general.more")}`}
          </Link>
        )}
      </Box>

      <Dialog
        open={isListDialogOpen}
        onClose={toggleListDialog(false)}
        company={company}
        onClickItem={setItem}
      />
      <CatalogFormDialog
        catalog={itemEdit || {}}
        DialogProps={{
          open: isEditDialogOpen,
          onClose: toggleEditDialog(false),
          TransitionProps: {
            onExited: setItem(null)
          }
        }}
      />
    </>
  )
}

const Dialog = props => {
  const { t } = useTranslation()
  const { company, ...rest } = props
  const {
    catalogs,
    name,
    totalOwnedCatalogs,
    unlimitedCatalogLicenses,
    catalogLicenses
  } = company
  const totalCatalogs = catalogs.length

  function onClose() {
    if (rest.onClose) {
      rest.onClose({}, "backdropClick")
    }
  }

  const catalagsOwned = catalogs.filter(catalog => {
    return getCatalogStatus(catalog, company) === "Owned"
  })

  const catalogsFromOtherCompany = catalogs.filter(catalog => {
    return getCatalogStatus(catalog, company) === "Shared"
  })

  const Summary = () => {
    if (!catalogs.length) {
      return <Typography>{t("view.adminCompanies.noCatalogs")}</Typography>
    }

    const allowedCatalogs = unlimitedCatalogLicenses
      ? "∞"
      : String(catalogLicenses)

    return (
      <>
        <Typography
          variant="body2"
          style={{ color: statusColor["Owned"].color }}
        >
          {`${totalOwnedCatalogs}/${allowedCatalogs} ${t(
            "view.adminCompanies.owned"
          )}`}
        </Typography>

        <Typography
          variant="body2"
          style={{ color: statusColor["Shared"].color }}
        >
          {`${catalogsFromOtherCompany.length} ${t(
            "view.adminCompanies.fromOtherCompanies"
          )}`}
        </Typography>
      </>
    )
  }

  return (
    <DialogMui {...rest} fullWidth maxWidth="xs">
      <DialogTitle onClose={onClose}>
        <Box display="flex" gridGap={8} alignItems="baseline">
          <Typography variant="h6">{name}</Typography>
          <Typography>
            {totalCatalogs}&nbsp;
            {totalCatalogs > 1
              ? t("view.adminCompanies.catalogs")
              : t("view.adminCompanies.catalog")}
          </Typography>
        </Box>
      </DialogTitle>

      <Box display="flex" gridGap={8} paddingX={2}>
        <Summary />
      </Box>

      <List>
        {catalagsOwned.map(catalog => (
          <CatalogItem
            key={catalog.id}
            catalog={catalog}
            status="Owned"
            onClickItem={props.onClickItem}
          />
        ))}
        {catalogsFromOtherCompany.map(catalog => (
          <CatalogItem
            key={catalog.id}
            catalog={catalog}
            status="Shared"
            onClickItem={props.onClickItem}
          />
        ))}
      </List>
    </DialogMui>
  )
}

const CatalogItem = props => {
  const { catalog, status, onClickItem } = props

  return (
    <ListItem button onClick={onClickItem(catalog)}>
      <ListItemText primary={catalog.name} />
      <ListItemSecondaryAction>
        <CatalogStatusChip status={status} />
      </ListItemSecondaryAction>
    </ListItem>
  )
}

function getCatalogStatus(catalog, company) {
  return String(catalog.company) === company.id ? "Owned" : "Shared"
}

const statusColor = {
  Owned: {
    backgroundColor: green[300],
    color: green[900]
  },
  Shared: {
    backgroundColor: grey[400],
    color: grey[800]
  }
}

const CatalogStatusChip = props => {
  return (
    <Chip
      size="small"
      label={props.status}
      style={{ ...statusColor[props.status] }}
    />
  )
}

export default Catalogs
